import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../../assets/css/mentor/mentordashboard/Enrolledstudents.css";
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';


// ── Dummy Data ──
const dummyStudents = [
  {
    id: 1,
    studentName: "Sarah Ahmed",
    studentImage: "https://i.pravatar.cc/150?img=1",
    areaOfHelp: "Web Development",
    enrolledCourses: [
      {
        id: 1,
        name: "Full Stack Web Development",
        progress: 72,
        startDate: "Jan 10, 2025",
        status: "In Progress",
      },
      {
        id: 2,
        name: "React Advanced Patterns",
        progress: 45,
        startDate: "Feb 01, 2025",
        status: "In Progress",
      },
    ],
  },
  {
    id: 2,
    studentName: "Ali Hassan",
    studentImage: "https://i.pravatar.cc/150?img=2",
    areaOfHelp: "React & Node.js",
    enrolledCourses: [
      {
        id: 3,
        name: "Node.js & Express API",
        progress: 88,
        startDate: "Dec 05, 2024",
        status: "In Progress",
      },
      {
        id: 4,
        name: "MongoDB & Mongoose",
        progress: 100,
        startDate: "Nov 01, 2024",
        status: "Completed",
      },
    ],
  },
  {
    id: 3,
    studentName: "Fatima Khan",
    studentImage: "https://i.pravatar.cc/150?img=3",
    areaOfHelp: "Python & Data Science",
    enrolledCourses: [
      {
        id: 5,
        name: "Python for Data Science",
        progress: 60,
        startDate: "Jan 20, 2025",
        status: "In Progress",
      },
      {
        id: 6,
        name: "Machine Learning Basics",
        progress: 30,
        startDate: "Feb 10, 2025",
        status: "In Progress",
      },
      {
        id: 7,
        name: "Data Visualization",
        progress: 100,
        startDate: "Dec 01, 2024",
        status: "Completed",
      },
    ],
  },
  {
    id: 4,
    studentName: "Usman Raza",
    studentImage: "https://i.pravatar.cc/150?img=4",
    areaOfHelp: "Mobile Development",
    enrolledCourses: [
      {
        id: 8,
        name: "React Native Fundamentals",
        progress: 55,
        startDate: "Jan 05, 2025",
        status: "In Progress",
      },
    ],
  },
];

// ── Progress Bar ──
const ProgressBar = ({ value }) => (
  <div className="ec-progress-track">
    <div
      className={`ec-progress-fill ${value === 100 ? "ec-progress-done" : "ec-progress-active"}`}
      style={{ width: `${value}%` }}
    />
  </div>
);

const EnrolledCourses = ({ students = [] }) => {
  const [search, setSearch] = useState("");

  const displayStudents = students.length > 0 ? students : dummyStudents;

  // Filter by student name or course name
  const filtered = displayStudents.filter(
    (s) =>
      s.studentName.toLowerCase().includes(search.toLowerCase()) ||
      s.enrolledCourses.some((c) =>
        c.name.toLowerCase().includes(search.toLowerCase()),
      ),
  );

  const totalCourses = displayStudents.reduce(
    (sum, s) => sum + s.enrolledCourses.length,
    0,
  );
  const totalStudents = displayStudents.length;
  const completedCourses = displayStudents.reduce(
    (sum, s) =>
      sum + s.enrolledCourses.filter((c) => c.status === "Completed").length,
    0,
  );

  return (
    <MyMasterLayout>
      <div className="ec-wrapper">
        {/* ── PAGE HEADER ── */}
        <div className="ec-page-header">
          <div className="ec-header-left">
            <div className="ec-header-icon">
              <i className="bi bi-journal-bookmark-fill"></i>
            </div>
            <div>
              <h1 className="ec-page-title">Enrolled Courses</h1>
              <p className="ec-page-subtitle">
                Track your students' course progress
              </p>
            </div>
          </div>

          {/* Search */}
          <div className="ec-search-box">
            <i className="bi bi-search ec-search-icon"></i>
            <input
              type="text"
              className="ec-search-input"
              placeholder="Search student or course..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* ── STATS ROW ── */}
        <div className="ec-stats-row">
          <div className="ec-stat-card">
            <div className="ec-stat-icon ec-stat-icon-blue">
              <i className="bi bi-people-fill"></i>
            </div>
            <div>
              <p className="ec-stat-number">{totalStudents}</p>
              <p className="ec-stat-label">Total Students</p>
            </div>
          </div>
          <div className="ec-stat-card">
            <div className="ec-stat-icon ec-stat-icon-maroon">
              <i className="bi bi-journal-bookmark-fill"></i>
            </div>
            <div>
              <p className="ec-stat-number">{totalCourses}</p>
              <p className="ec-stat-label">Total Courses</p>
            </div>
          </div>
          <div className="ec-stat-card">
            <div className="ec-stat-icon ec-stat-icon-green">
              <i className="bi bi-patch-check-fill"></i>
            </div>
            <div>
              <p className="ec-stat-number">{completedCourses}</p>
              <p className="ec-stat-label">Completed</p>
            </div>
          </div>
          <div className="ec-stat-card">
            <div className="ec-stat-icon ec-stat-icon-orange">
              <i className="bi bi-play-circle-fill"></i>
            </div>
            <div>
              <p className="ec-stat-number">
                {totalCourses - completedCourses}
              </p>
              <p className="ec-stat-label">In Progress</p>
            </div>
          </div>
        </div>

        {/* ── STUDENTS + COURSES LIST ── */}
        {filtered.length === 0 ? (
          <div className="ec-empty">
            <i className="bi bi-search ec-empty-icon"></i>
            <p className="ec-empty-title">No results found</p>
            <p className="ec-empty-sub">
              Try searching a different name or course
            </p>
          </div>
        ) : (
          filtered.map((s, si) => (
            <div key={s.id} className="ec-student-card">
              {/* Student Header */}
              <div className="ec-student-header">
                <img
                  src={s.studentImage || "https://i.pravatar.cc/150"}
                  alt={s.studentName}
                  className="ec-student-avatar"
                />
                <div className="ec-student-info">
                  <p className="ec-student-name">{s.studentName}</p>
                  <p className="ec-student-count">
                    {s.enrolledCourses.length} enrolled course
                    {s.enrolledCourses.length !== 1 ? "s" : ""}
                  </p>
                </div>
                <span className="ec-area-badge">{s.areaOfHelp}</span>
              </div>

              {/* Courses Table */}
              {s.enrolledCourses.length === 0 ? (
                <p className="ec-no-courses">No courses enrolled yet.</p>
              ) : (
                <div className="ec-table-wrap">
                  <table className="ec-table">
                    <thead>
                      <tr className="ec-thead">
                        <th className="ec-th ec-th-left">Course Name</th>
                        <th className="ec-th ec-th-center">Started</th>
                        <th className="ec-th ec-th-center ec-th-progress">
                          Progress
                        </th>
                        <th className="ec-th ec-th-center">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {s.enrolledCourses.map((course, ci) => (
                        <tr
                          key={course.id}
                          className={`ec-tr ${ci % 2 === 0 ? "ec-tr-even" : "ec-tr-odd"}`}
                        >
                          {/* Course Name */}
                          <td className="ec-td">
                            <div className="ec-course-cell">
                              <div
                                className={`ec-course-icon ${course.progress === 100 ? "ec-icon-done" : "ec-icon-active"}`}
                              >
                                <i
                                  className={`bi ${course.progress === 100 ? "bi-patch-check-fill" : "bi-book-fill"}`}
                                ></i>
                              </div>
                              <span className="ec-course-name">
                                {course.name}
                              </span>
                            </div>
                          </td>

                          {/* Start Date */}
                          <td className="ec-td ec-td-center">
                            <span className="ec-date">{course.startDate}</span>
                          </td>

                          {/* Progress */}
                          <td className="ec-td ec-td-center ec-td-progress">
                            <div className="ec-progress-row">
                              <span className="ec-progress-label">
                                Progress
                              </span>
                              <span
                                className={`ec-progress-pct ${course.progress === 100 ? "ec-pct-done" : "ec-pct-active"}`}
                              >
                                {course.progress}%
                              </span>
                            </div>
                            <ProgressBar value={course.progress} />
                          </td>

                          {/* Status */}
                          <td className="ec-td ec-td-center">
                            <span
                              className={`ec-status ${course.status === "Completed" ? "ec-status-done" : "ec-status-progress"}`}
                            >
                              <i
                                className={`bi ${course.status === "Completed" ? "bi-check-circle-fill" : "bi-play-circle-fill"}`}
                              ></i>
                              {course.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </MyMasterLayout>
  );
};

export default EnrolledCourses;
